<template>
  <v-app class="cover-img">
    <ScrollToTopBtn />
    <TheHeader />
    <v-main>
      <router-view />
    </v-main>
    <TheFooter />
  </v-app>
</template>

<script>
import TheHeader from "@/components/Apps/TheHeader.vue";
import TheFooter from "@/components/Apps/TheFooter.vue";
import ScrollToTopBtn from "@/components/Apps/ScrollToTopBtn.vue";
export default {
  name: "App",
  components: {
    TheHeader,
    TheFooter,
    ScrollToTopBtn,
  },
};
</script>
<style lang="scss" scoped>
.cover-img {
  background-image: url("@/assets/imgs/cover.png");
  // background-size: cover;
  background-repeat: repeat;
}
</style>
